import PropTypes from 'prop-types';
import React from 'react'

import { resetPassword } from '~/actions/sessions'

export default class extends React.Component {
    static propTypes = {
		session: PropTypes.object,
		history: PropTypes.object.isRequired
	};

    state = {
        error: ''
    };

    resetPassword = (e) => {

		e.preventDefault();

		let key = this.props.routeParams.key,
			password = this.refs.pass.value,
			cpassword = this.refs.cpass.value;

		if( !password || !cpassword ) this.setState({ error: 'Complete all password fields' })
		if( password !== cpassword ) this.setState({ error: "Passwords don't match!" })

		this.props.dispatch( resetPassword(key, password, cpassword) )

	};

    componentDidUpdate(prevProps, prevState) {
		if( !prevProps.session.passwordReset && this.props.session.passwordReset ) {
			this.props.history.push('/login#email')
		}
	}

    render() {

		return (

			<div className="slide-transition">
				<fieldset>
					<div className="slide-holder">
						<img src="/img/logo.png" className="mbot40 pleft50 pright50 img-responsive" alt=""/>
						<div id="reset-slide" className="slide-wrapper">
							<header className="bg-deep-main ptop20 pbot20">
								<h4 className="text-dark-gray text-center mtop0 mbot0">Reset Your Password</h4>
							</header>
							<div className="inner no-footer">

								<div className="bg-light-main bg-slightly-transparent transparent back">
									<form onSubmit={this.resetPassword}>
										<div>
											<div className="reset-email">

												{ !!this.state.error && 
													<p className="ptop15 pbot15 small text-pale-danger text-center">{this.state.error}</p>
												}

												<div className="input">
													<i className="icon-lock"></i>
													<input type="password" name="pass" ref="pass" placeholder="New Password" className="form-control" />
													<div className="clearfix"></div>
												</div>

												<div className="input">
													<i className="icon-rotation-lock"></i>
													<input type="password" name="cpass" ref="cpass" placeholder="Confirm Password" className="form-control" />
													<div className="clearfix"></div>
												</div>

											</div>
											<div className="clearix"></div>
											<footer className="bg-deep-main text-center text-white">
												<button type="submit" className="p20 btn btn-none btn-block">Change my password</button>
											</footer>
										</div>
									</form>
								</div>

							</div>
						</div>
					</div>
				</fieldset>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/PasswordReset/index.jsx